import { useSelector } from 'react-redux';
import { useTracking } from 'react-tracking';
import { PetType } from '../constants';
import { getAgeInYears } from '../util';
import {
  baseRequest,
  customTrackEvent,
  EVENT_TYPE,
  getCurrentPrice,
  getPetPowerups,
  getPlanLimit,
  getQuotePlanInfo,
} from './baseRequest';

const useTrackingPlanSelection = () => {
  const { trackEvent } = useTracking({ }, { dispatch: customTrackEvent });
  const store = useSelector(({ quoting }) => quoting);
  const {
    data,
    parameters: { groupCodeDscr, email },
    petQuoteSelected,
    quoteSelectedValues,
    subId,
  } = store;

  function trackPlanSelection({
    planIndex,
    planLimit,
  }) {
    const currentPet = data.petQuoteResponseList
      .find((element) => element.petQuoteId === petQuoteSelected);

    const petQuoteInf = getQuotePlanInfo({
      petId: currentPet.petQuoteId,
      quoteSelectedValues,
    });

    const modifierList = data.insuranceProduct.InsuranceModifiers;
    const petQuotePowerups = getPetPowerups({ currentPet, modifierList });

    const price = getCurrentPrice({
      currentPet,
      petIdSelected: petQuoteSelected,
      planIndex,
      quoteSelectedValues,
    });

    const petInfo = {
      age: getAgeInYears(currentPet.petAgeName),
      breed: currentPet.breedName,
      gender: currentPet.genderName.toLowerCase(),
      name: currentPet.petName,
      quote: {
        annual_premium: price.AnnualPremium,
        deductible: petQuoteInf.deductible,
        extra_care: petQuotePowerups.extraCarePack,
        limit: getPlanLimit(planLimit),
        monthly_premium: price.MonthlyPremium,
        reimbursement: petQuoteInf.reimbursement,
        vet_fees: petQuotePowerups.vetFees,
        wellness: petQuotePowerups.wellness,
      },
      species: currentPet.petType === PetType.Dog.value ? 'dog' : 'cat',
      zip: data.zipCode,
    };

    trackEvent({
      ...baseRequest({
        codeMask: groupCodeDscr,
        email,
        promoCode: data.groupCode || '',
        subId: subId.Value,
      }),
      event: EVENT_TYPE.PLAN_SELECTION,
      pet: petInfo,
    });
  }

  return { trackPlanSelection };
};

export { useTrackingPlanSelection };
